<template>
  <Dropdown bclass="btn-block text-light-high" ref="dropdown">
    <template v-slot:button>
      <div class="gp_language-item d-flex">
        <!-- <img class="gp_language-item_icon" :src="selected.icon" :alt="selected.text" /> -->
        <span class="gp_language-item_text text-light-high">{{ selected.text }}</span>
      </div>
    </template>
    <template v-slot:default>
      <div class="gp_dropdown-item gp_language-item d-flex" :class="{ active: item.value == internalValue }" v-for="(item, ind) in languages" :key="ind" @click="changeVal(item.value)">
        <!-- <img class="gp_language-item_icon" :src="require('@/core/assets/flags/' + item.icon)" :alt="item.text" v-if="item.icon != 'none'" />
        <img class="gp_language-item_icon" v-else /> -->
        <!-- <hr class="mx-2 bg-grey3" style="height: 22px; width: 1px;" /> -->
        <span class="gp_language-item_text">{{ item.text }}</span>
      </div>
    </template>
  </Dropdown>
</template>

<script>
export default {
  name: "SelectLang",
  props: {
    value: {
      type: String,
      default: "en"
    }
  },
  data() {
    return {
      internalValue: ""
    };
  },
  computed: {
    languages() {
      return [
        {
          text: "English",
          value: "en",
          icon: "en.png"
        },
        {
          text: "Français",
          value: "fr",
          icon: "fr.png"
        }
        // {
        //   text: "中文",
        //   value: "cn",
        //   icon: "cn.svg"
        // },
        // {
        //   text: "Other",
        //   value: "--",
        //   icon: "none.svg"
        // }
      ];
    },
    selected() {
      let found = this.languages.find(item => {
        return item.value === this.internalValue;
      });

      if (found) {
        return {
          text: found.text,
          value: found.value,
          icon: require("@/core/assets/flags/" + found.icon)
        };
      }

      return {
        text: "None",
        value: "",
        icon: require("@/core/assets/flags/none.svg")
      };
    }
  },
  watch: {
    value(newValue) {
      if (typeof newValue === "string") {
        this.setValue(newValue);
      }
    }
  },
  created() {
    this.setValue();
  },
  methods: {
    changeVal(value) {
      this.$emit("input", value);
      let $dropdown = this.$refs.dropdown;
      if ($dropdown) $dropdown.closeDropdown();
    },
    setValue(newValue = null) {
      let value = newValue || this.value;

      if (this.languages.some(item => item.value === value.toLowerCase())) {
        this.internalValue = value;
        return;
      }

      this.internalValue = this.languages[0].value;
    }
  }
};
</script>

<style lang="scss" scoped>
.gp_language-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* img.gp_language-item_icon {
    width: 30px;
    margin-right: 8px;
  } */
  span.gp_language-item_text {
  }

  &.active {
    color: $cPrimary;
    font-weight: bold;
    background: transparent;
  }
}
::v-deep {
  .dropdown_toggle {
    // background: transparent;
    // border: 1px solid #c4c6d4;
    // border-radius: 0px;
    // padding: 11px 16px;
    // justify-content: flex-start;
    i {
      // margin-left: auto;
      color: $textLightModeHigh;
    }
    &:hover, &.active {
      i {
        color: $mono3;
      }
    }
  }
  .gp_dropdown_list {
    padding: 0 !important;
  }
}
</style>
